export default __webpack_public_path__ + "static/media/umbra-hero.9461d20c.mp4";